import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'ui-components/default-props/noop';
import { MarketplaceSettings } from '@shipstation/connections-ui';
import { useCommonCuiProps } from './helpers/use-common-cui-props';

export const SSMarketplaceSettings = ({ onError = noop, onCancel = noop, onSave = noop, storeGuid, marketplaceApiCode }) => {
  const commonCuiProps = useCommonCuiProps();
  return (
    <MarketplaceSettings
      {...commonCuiProps}
      marketplaceApiCode={marketplaceApiCode}
      onCancel={onCancel}
      onError={onError}
      onSave={onSave}
      storeGuid={storeGuid}
    />
  );
};

SSMarketplaceSettings.propTypes = {
  onError: PropTypes.func,
  onCancel: PropTypes.func,
  onSave: PropTypes.func,
  storeGuid: PropTypes.string,
  marketplaceApiCode: PropTypes.string,
};
